import { CAMPAIGN_BRAND_CODES, CampaignBrandCode, INITIAL_CAMPAIGN_BRAND_FLAGS } from '@/constants/campaignBrands'

import type { CampaignBrandFlags, ContentByBrandForm } from '../AccelerationForm.types'

export const getSelectedCampaignBrands = (brand: CampaignBrandFlags): CampaignBrandCode[] =>
  CAMPAIGN_BRAND_CODES.filter((code) => brand[code])

export const normalizeCampaignBrandFlags = (brand?: Partial<CampaignBrandFlags> | null): CampaignBrandFlags => ({
  BOT: brand?.BOT ?? INITIAL_CAMPAIGN_BRAND_FLAGS.BOT,
  QDB: brand?.QDB ?? INITIAL_CAMPAIGN_BRAND_FLAGS.QDB,
  BLZ: brand?.BLZ ?? INITIAL_CAMPAIGN_BRAND_FLAGS.BLZ,
  EUD: brand?.EUD ?? INITIAL_CAMPAIGN_BRAND_FLAGS.EUD
})

export const serializeContentByBrandForApi = (
  brand: CampaignBrandFlags,
  contentByBrand: ContentByBrandForm
): ContentByBrandForm => {
  const serialized: ContentByBrandForm = {}

  for (const code of getSelectedCampaignBrands(brand)) {
    const buttonUrl = contentByBrand[code]?.buttonUrl?.trim()
    if (buttonUrl) {
      serialized[code] = { buttonUrl }
    }
  }

  return serialized
}

export const resolveSharedContentButtonUrl = (
  brand: CampaignBrandFlags,
  contentByBrand: ContentByBrandForm,
  fallbackButtonUrl = ''
): string => {
  const selectedBrands = getSelectedCampaignBrands(brand)
  const firstBrandUrl = selectedBrands.length > 0 ? contentByBrand[selectedBrands[0]]?.buttonUrl?.trim() : ''

  return firstBrandUrl || fallbackButtonUrl.trim()
}
